<template>
  <div>
    <div class="page-body overflow-visible">
      <template v-if="isBusy || (items && items.length > 0)">
        <div class="page-table-container overflow-visible">
          <b-table
            id="location-files"
            ref="location_files"
            class="custom-table mb-0"
            selectable
            select-mode="single"
            responsive
            :busy="isBusy"
            :items="items"
            :fields="fields"
            no-provider-filtering
            no-provider-paging
            no-provider-sorting
          >
            <template #table-busy>
              <div class="text-center text-success my-2">
                <b-spinner class="align-middle"/>
                <strong>Загрузка</strong>
              </div>
            </template>

            <template #cell(path)="row">
              <b-link style="color: #1A9167 !important;" @click="onDownload(row.item.id, row.item.path)">{{row.item.path}}</b-link>
            </template>

            <template #head(action)="row">
              <b-btn variant="link" style="color: #1A9167 !important; text-decoration: none !important;" :disabled="isDisabled" @click="onAdd">
                <v-icon name="buttons/plus" :size="12" class="mr-1"/>
                Добавить
              </b-btn>
            </template>

            <template #cell(action)="row">
              <b-button variant="link" @click="onRemove(row)" :disabled="isDisabled">
                <v-icon name="buttons/trash" :size="16"/>
              </b-button>
            </template>
          </b-table>
        </div>

        <div class="page-pagination">
          <pagination-footer
            :total-rows="items.length"
            :per-page="perPage"
            :current-page.sync="currentPage"
            @per-page-change="onPerPageChange"
          >
            <template #footer-list>
              Всего файлов: <b>{{items.length}}</b>
            </template>
          </pagination-footer>
        </div>
      </template>

      <div v-else class="empty-state-container">
        <v-icon name="navbar/empty_table" :size="90"/>
        <h5>Нет добавленных документов.</h5>
        <p>Добавьте файл прямо сейчас</p>
        <b-btn class="custom-btn-primary mt-1" :disabled="isDisabled" @click.stop="onAdd">
          <v-icon name="buttons/plus" :size="12" class="mr-1"/>
          Новый документ
        </b-btn>
      </div>
    </div>

    <b-modal
      id="modal-file"
      ref="modal_file"
      title="Загрузка файла"
      modal-class="custom-modal"
      @show="onResetModal"
      @hidden="onResetModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-file
          placeholder="Файлы не выбраны"
          browse-text="Выбрать"
          id="input_number"
          size="sm"
          autocomplete="off"
          v-model="newFile"
        />
      </form>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button class="custom-btn-secondary mr-2" @click="handleCancel">
            Отменить
          </b-button>
          <b-button class="custom-btn-primary" @click="handleOk">
            Добавить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import locations from "../../network/locations";
  import helpers from "../../utilites/helpers";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";

export default {
  name: "LocationFiles",
  components: {PaginationFooter},
  mixins: [
    locations,
    helpers
  ],
  props: {
    isDisabled: Boolean,
  },
  data() {
    return {
      location_id: 0,
      newFile: null,
      items: [],
      fields: [
        {
          key: 'path',
          label: 'Файл',
        },
        {
          key: 'action',
          label: 'Действие',
          class: 'location-files-action text-center'
        },
      ],
      perPage: 10,
      currentPage: 1,
      isBusy: false,
      deleteRow: {
        id: null,
        path: ''
      },
    }
  },
  methods: {
    configure(locationId) {
      this.location_id = locationId;
      this.getItems();
    },
    async getItems() {
      this.isBusy = true;
      const result = await this.getLocationFilesByLocationId(this.location_id);
      this.isBusy = false;

      this.items = result.data;
    },
    onAdd() {
      if (this.location_id === 0) {
        this.$bvToast.toast(`Сначала создайте объект. Нажмите кнопку "Сохранить"`, {
          title: 'Ошибка добавления файла',
          variant: 'danger',
          autoHideDelay: 3000,
          solid: true
        });
        return;
      }

      this.$bvModal.show('modal-file');
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление файла";
      const message = `Вы действительно хотите удалить файл ${this.deleteRow.path}?`;
      this.showModalDelete(title, message, () => {
        this.removeItem(this.deleteRow);
      });
    },
    onResetModal() {
      this.newFile = null;
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmit();
    },
    handleCancel() {
      this.$refs.modal_file.hide();
    },
    async handleSubmit() {
      if (!this.newFile) return;

      let formData = new FormData();
      formData.append("file", this.newFile, this.newFile.name);

      const result = await this.postLocationFile(this.location_id, formData);

      if (result.error) {
        console.log(result.error);
        return;
      }

      this.$nextTick(() => {
        this.$bvModal.hide('modal-file');
      })

      await this.getItems();
    },
    async onDownload(id, fileName) {
      const result = await this.getLocationFile(id);

      if (result.data == null) {
        return;
      }

      const file = new File([result.data], fileName)
      const link = document.createElement('a');
      link.href = this.blobURLFromFile(file);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    blobURLFromFile(file) {
      if (file !== null) {
        return URL.createObjectURL(file);
      }
      return '';
    },
    async removeItem(item) {
      const result = await this.deleteLocationFile(item);

      if (!result.data) return;

      await this.getItems();
    },
    onPerPageChange(newPerPage) {
      this.perPage = Number(newPerPage);
      this.currentPage = 1;
    },
  }
}
</script>

<style>
#location-files th {
  text-align: center;
  vertical-align: middle;
}

#location-files td {
  text-align: left;
  vertical-align: middle;
}

.location-files-action {
  width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationFiles.vue